var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnooze(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40709_63912)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.0368,
    cy: 10.6735,
    r: 5.99282,
    stroke: "#252525",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58842 8.72559H11.2714C11.3597 8.72559 11.4103 8.82622 11.3576 8.89707L8.71591 12.4491C8.66322 12.52 8.71379 12.6206 8.80208 12.6206H11.4851",
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.8487,
    y1: 3.00293,
    x2: 16.7793,
    y2: 5.93351,
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 4.89447,
    y2: -0.75,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 7.21094 3.00293)",
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40709_63912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooze);
export default __webpack_public_path__ + "static/media/snooze.f420be61.svg";
export { ForwardRef as ReactComponent };